import React from 'react';
import type { ChannelDashboardOverview, ChannelMediaAsset, ChannelMediaType } from '@troia-v3/types';

interface Props {
  channel: ChannelDashboardOverview['channel'];
  mediaType: ChannelMediaType;
  assets: ChannelMediaAsset[];
  caption: string;
}

export const PhonePreview: React.FC<Props> = ({ channel, mediaType, assets, caption }) => {
  const info = channel.accountInfo;
  const name = info?.verifiedName || info?.businessName || info?.pushName || channel.name;
  const initials = name.slice(0, 2).toUpperCase();
  const first = assets[0];
  const vertical = mediaType === 'reels' || mediaType === 'story';

  return (
    <div className="cdash-phone" data-testid="cdash-phone-preview">
      <div className="cdash-phone-head">
        <div className="cdash-phone-av">
          {info?.profilePictureUrl ? <img src={info.profilePictureUrl} alt={name} /> : <span>{initials}</span>}
        </div>
        <span className="cdash-phone-name">@{channel.identifier}</span>
      </div>
      <div className={`cdash-phone-media ${vertical ? 'ar-vertical' : 'ar-square'}`}>
        {first ? (
          first.type === 'video' ? <video src={first.mediaUrl} muted /> : <img src={first.mediaUrl} alt="" />
        ) : (
          <span className="cdash-phone-empty">Pré-visualização</span>
        )}
      </div>
      {caption ? (
        <div className="cdash-phone-cap">
          <b>@{channel.identifier}</b> {caption}
        </div>
      ) : null}
    </div>
  );
};
